import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {geoUtils} from '../utils/geo-utils';

class StateMapShapes extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    const widthDifferent = nextProps.width !== this.props.width;
    const heightDifferent = nextProps.height !== this.props.height;
    const stateDifferent = nextProps.stateFips !== this.props.stateFips;
    const dataDifferent = nextProps.data !== this.props.data;
    const dimXDiff = nextProps.dimX !== this.props.dimX;
    const dimYDiff = nextProps.dimY !== this.props.dimY;
    const yearDiff = nextProps.year !== this.props.year;

    return widthDifferent || heightDifferent || stateDifferent || dataDifferent || dimXDiff || dimYDiff || yearDiff;
  }

  getScale() {
    const props = this.props;
    return geoUtils.createMultiScale(props.dict, props.dimX, props.dimY, props.year, props.type);
  }

  render() {
    const paths = geoUtils.getMercatorStateCountyPaths(this.props.stateFips, this.props.width, this.props.height);
    const scale = this.getScale();

    return (
      <g className="StateMapShapes">
        {paths.map(d => {
          return (
            <path
              key={d.id}
              d={d.path}
              fill={scale(d)}
            ></path>
          );
        })}
      </g>
    )
  }
}

StateMapShapes.propTypes = {
  stateFips: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  data: PropTypes.array,
  dimX: PropTypes.string,
  dimY: PropTypes.string,
  year: PropTypes.number,
  type: PropTypes.string
};


export default StateMapShapes


// WEBPACK FOOTER //
// ./src/charts/StateMap/StateMapShapes.js